export default __webpack_public_path__ + "static/06-3b062390d99ca8e6942a54728fd60d96.png";